var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWord(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 128,
    height: 128,
    viewBox: "0 0 128 128",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1403_2310)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_1403_2310)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 6C16 2.68629 18.6863 0 22 0H106C109.314 0 112 2.68629 112 6V122C112 125.314 109.314 128 106 128H22C18.6863 128 16 125.314 16 122V6Z",
    fill: "#FCFCFD"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M16 6C16 2.68629 18.6863 0 22 0H106C109.314 0 112 2.68629 112 6V122C112 125.314 109.314 128 106 128H22C18.6863 128 16 125.314 16 122V6Z",
    fill: "#FCFCFD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22 0.8H106C108.872 0.8 111.2 3.12812 111.2 6V122C111.2 124.872 108.872 127.2 106 127.2H22C19.1281 127.2 16.8 124.872 16.8 122V6C16.8 3.12812 19.1281 0.8 22 0.8Z",
    stroke: "#DDE1E6",
    strokeWidth: 1.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22 128H106C109.314 128 112 125.314 112 122V118C112 121.314 109.314 124 106 124H22C18.6863 124 16 121.314 16 118V122C16 125.314 18.6863 128 22 128Z",
    fill: "#DDE1E6"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_1403_2310)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M91.2689 34H47.6091C46.1023 34 44.8809 35.2215 44.8809 36.7282V48.8837L70.1832 56.3256L93.9971 48.8837V36.7282C93.9971 35.2215 92.7757 34 91.2689 34Z",
    fill: "#41A5EE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.9971 48.8837H44.8809V63.7674L70.1832 68.2325L93.9971 63.7674V48.8837Z",
    fill: "#2B7CD3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.8809 63.7676V78.6513L68.6948 81.628L93.9971 78.6513V63.7676H44.8809Z",
    fill: "#185ABD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.6091 93.5353H91.269C92.7757 93.5353 93.9972 92.3139 93.9972 90.8071V78.6516H44.8809V90.8071C44.8809 92.3139 46.1023 93.5353 47.6091 93.5353Z",
    fill: "#103F91"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M62.9899 45.9071H44.8809V83.1164H62.9899C64.4946 83.1115 65.7132 81.8929 65.7181 80.3882V48.6353C65.7132 47.1306 64.4946 45.912 62.9899 45.9071Z",
    fill: "black",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M60.0131 47.3954H44.8809V81.6279H60.0131C61.5178 81.623 62.7364 80.4045 62.7413 78.8998V50.1236C62.7364 48.6189 61.5178 47.4003 60.0131 47.3954Z",
    fill: "black",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.7282 47.3954H60.016C61.5227 47.3954 62.7442 48.6168 62.7442 50.1236V77.4114C62.7442 78.9182 61.5227 80.1396 60.016 80.1396H32.7282C31.2215 80.1396 30 78.9182 30 77.4114V50.1236C30 48.6168 31.2215 47.3954 32.7282 47.3954Z",
    fill: "url(#paint0_linear_1403_2310)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.1931 68.3189C41.2467 68.7401 41.2824 69.1063 41.2988 69.4203H41.3613C41.3851 69.1226 41.4347 68.7639 41.5101 68.3442C41.5855 67.9245 41.6535 67.5698 41.714 67.28L44.5836 54.8998H48.2941L51.2709 67.094C51.4438 67.8522 51.5676 68.6208 51.6415 69.395H51.6906C51.7461 68.645 51.8495 67.8993 52.0002 67.1624L54.3741 54.8938H57.7512L53.5808 72.6352H49.6351L46.8072 60.886C46.7254 60.5481 46.6316 60.1061 46.5289 59.5628C46.4262 59.0195 46.3622 58.6221 46.3369 58.3721H46.2878C46.2551 58.6608 46.191 59.0895 46.0958 59.6581C46.0005 60.2266 45.9241 60.6473 45.8666 60.9202L43.2083 72.6322H39.1956L35.0029 54.8997H38.4411L41.0264 67.3053C41.0844 67.5598 41.1395 67.8992 41.1931 68.3189Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_1403_2310",
    x: 16,
    y: 0,
    width: 96,
    height: 128,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.16 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_1403_2310"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1403_2310",
    x1: 35.6883,
    y1: 45.2636,
    x2: 57.0559,
    y2: 82.2713,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2368C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#1A5DBE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1146AC"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1403_2310"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 128,
    height: 128,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_1403_2310"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 59.5349,
    fill: "white",
    transform: "translate(30 34)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWord);
export default __webpack_public_path__ + "static/media/word.e8cf927c4f795b8e12307c17c39b5762.svg";
export { ForwardRef as ReactComponent };